import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Collapse,
  CircularProgress,
  Grid,
  MenuItem,
  FormControl,
  Select,
  Box,
  FormLabel,
  Snackbar,
  Alert,
  TextField,
  InputLabel,
  Button,
  Stack,
} from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import { useTranslation } from "react-i18next";
import FunctionalAssessmentPage from "./components/functionalAssessorPage";
import EvidenceProviderPage from "./components/EvidenceProviderPage";

import AssessorKpiPage from "./components/AssessmentPage";
import { buttonStyles } from "services/utils";

const AssessPage = () => {
  const { t } = useTranslation();
  const [view, setView] = useState(0);

  return (
    <MDBox>
      <MDBox>
        <Stack
          direction={{ xs: "column", sm: "row" }} // Stack vertically on small screens
          spacing={1}
          alignItems="center" // Center buttons when stacked
        >
          <Button
            sx={{ ...buttonStyles(view === 0), width: { xs: "100%", sm: "auto" } }}
            variant={view === 0 ? "contained" : "outlined"}
            onClick={() => setView(0)}
          >
            {t("user.assess.primaryAssessor")}
          </Button>
          <Button
            sx={{ ...buttonStyles(view === 1), width: { xs: "100%", sm: "auto" } }}
            variant={view === 1 ? "contained" : "outlined"}
            onClick={() => setView(1)}
          >
            {t("user.assess.secondaryAssessor")}
          </Button>
          <Button
            sx={{ ...buttonStyles(view === 2), width: { xs: "100%", sm: "auto" } }}
            variant={view === 2 ? "contained" : "outlined"}
            onClick={() => setView(2)}
          >
            {t("user.assess.functionalAssessor")}
          </Button>
          <Button
            sx={{ ...buttonStyles(view === 3), width: { xs: "100%", sm: "auto" } }}
            variant={view === 3 ? "contained" : "outlined"}
            onClick={() => setView(3)}
          >
            {t("user.assess.evidenceProvider")}
          </Button>
        </Stack>
      </MDBox>
      {/* {view == 0 ? (
        <AssessorKpiPage isPrimary={true} />
      ) : view == 1 ? (
        <AssessorKpiPage isPrimary={false} />
      ) : (
        <FunctionalAssessmentPage />
      )} */}
      {view === 0 && <AssessorKpiPage isPrimary={true} />}
      {view === 1 && <AssessorKpiPage isPrimary={false} />}
      {view === 2 && <FunctionalAssessmentPage />}
      {view === 3 && <EvidenceProviderPage />}
    </MDBox>
  );
};

export default AssessPage;
